import React from 'react';
import { InfinitySpin } from 'react-loader-spinner';

export default function Spinner() {
  return <InfinitySpin color="rgb(41, 80, 152)" ariaLabel="loading" />;
}
